import { Box, Button, CheckboxGroup, Spinner, Text } from "@radix-ui/themes";
import { Control, Controller, FieldErrors } from "react-hook-form";
import styles from './CheckboxGroupComponent.module.scss';

interface CheckboxGroupProps {
  name: string;
  label: string;
  control: Control<any>;
  errors: FieldErrors<any>;
  style?: any;
  options?: { value: string; label: string }[];
  itemsLoading?: boolean;
  itemsError?: boolean;
  handleItemClick?: any
  handleItemChange?: any
  composedName?: { parent: any, prop: any }
  required?: boolean;
  disabled?: boolean;
}

const CheckboxGroupComponent = ({
  name,
  label,
  control,
  errors,
  style,
  options,
  itemsLoading,
  itemsError,
  handleItemClick,
  handleItemChange,
  composedName,
  required,
  disabled
}: CheckboxGroupProps) => {

  const castedErrors = errors as Record<string, any>;

  const composedError = composedName && composedName.parent && composedName.prop
    ? castedErrors?.[composedName.parent]?.[composedName.prop]
    : undefined;
  return <Box {...style}>
    <Text as="label" size="2" className={styles.label}>{<span>{label} {required && <span style={{ color: 'red' }}>*</span>}</span>}</Text>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (

        <>
          {options?.length != 0 && (
            <Box style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem" }}>
              <Button
                onClick={() => {
                  if (options) {
                    field.onChange(options.map((option) => option.value));
                  }
                }}
                type="button"
              >
                Marcar todos
              </Button>
              <Button
                onClick={() => {
                  field.onChange([]);
                }}
                type="button"
              >
                Desmarcar todos
              </Button>
            </Box>
          )}

          <CheckboxGroup.Root
            onValueChange={(value) => {
              field.onChange(value)
              if (handleItemChange && typeof handleItemChange === `function`) {
                handleItemChange(value)
              }
            }}
            value={field.value || []}
            disabled={disabled}
          >
            <Box style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
              gap: '1rem',
              maxWidth: '100%',
              overflow: 'hidden',
              overflowY: 'scroll',
              scrollBehavior: 'smooth',
              maxHeight: '300px',
              wordWrap: 'break-word',
            }}>
              {itemsLoading ? (
                <Spinner loading />
              ) : itemsError ? (
                <Text>Erro ao carregar items</Text>
              ) : options && options?.length > 0 ? (
                options?.map((option) => (
                  <CheckboxGroup.Item key={option.value} value={option.value} onClick={() => {
                    if (handleItemClick && typeof handleItemClick === `function`) {
                      handleItemClick(option.value)
                    }
                  }}>
                    {option.label}
                  </CheckboxGroup.Item>
                ))
              ) : (
                <Text>Nenhum item disponível</Text>
              )}
            </Box>
          </CheckboxGroup.Root>
        </>
      )}
    />
    {composedError ? (
      <Text color="red" size="1">
        {composedError.message as string}
      </Text>
    ) : (
      errors?.[name] && (
        <Text color="red" size="1">
          {errors?.[name]?.message as string}
        </Text>
      )
    )}
  </Box>
};

export default CheckboxGroupComponent;
